<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="flex flex-column gap-2  mx-auto container-width-sidebar">
    <main class="grid formgrid p-fluid app-container-input-blue">
      <div class="field col-12">
        <p-iconField iconPosition="left">
          <p-inputIcon styleClass="pi pi-envelope"></p-inputIcon>
        <input pInputText class="container-input w-full"
               [placeholder]="'components.app-password-reset-form.correo' | translate"
               formControlName="correo" id="correo" type="text" />
        </p-iconField>
        <ng-container *ngIf="form.get('correo')?.invalid && form.get('correo')?.touched">
          <app-form-group-error-message [control]="form.get('correo')"></app-form-group-error-message>
        </ng-container>
      </div>
      <div>
        <a (click)="onBack()" class="cursor-pointer color-blue-2 underline ml-3">
          {{"form.button.atras" | translate }}</a>
      </div>
      <div class="col-12 mt-4">
        <div class="flex justify-content-center gap-3">
          <button pButton type="submit" [label]="'components.app-password-reset-form.restablecer-button' | translate"
                  class="border-round-xl w-fit px-5 w-20rem"></button>
        </div>
      </div>
    </main>
  </div>
</form>
<p-toast></p-toast>

